
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import CategoriesMenu from '/home/circleci/app/packages/layout-categories-menu-component/src/entries/CategoriesMenu';

const element = typeof document !== 'undefined' && document.querySelector('#CategoriesMenu');
if (element) {
    const props = window.initialData['CategoriesMenu'];
    ReactDOM.hydrate(
        <CategoriesMenu {...props}/>,
        element
    );
}
export default CategoriesMenu;
